import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Languages } from 'lucide-react'
// import { useNavigate } from 'react-router-dom'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select'
import { cn } from '@/lib/utils'

interface LanguageSelectorProps {
  className?: string
  basic?: boolean
}
export const LanguageSelector: React.FC<LanguageSelectorProps> = ({ className, basic }) => {
  const { i18n } = useTranslation()
  const [language, setLanguage] = useState('en') // Por defecto inglés

	useEffect(() => {
		const storedLanguage = localStorage.getItem('language') ?? 'en'
		const currentLanguage = storedLanguage.startsWith('es') ? 'es' : 'en'
		setLanguage(currentLanguage)
	}, [i18n.language])

	const changeLanguage = (value: string): void => {
		const newLanguage = value === 'es' ? 'es' : 'en'
		i18n.changeLanguage(newLanguage)
		setLanguage(newLanguage)
		localStorage.setItem('language', newLanguage)
	}

  return (
    <>
      {basic === true
        ? (
          <Select onValueChange={changeLanguage} value={language}>
            <SelectTrigger className={cn('w-auto flex justify-center items-center bg-transparent after:text-primary gap-2' , className, 'border-none', 'basic-select')}>
              <Languages className='ml-2 text-white' size={15} />
            </SelectTrigger>
            <SelectContent className='border-none bg-white text-primary'>
              <SelectItem value='en'>EN</SelectItem>
              <SelectItem value='es'>ES</SelectItem>
            </SelectContent>
          </Select>
        ) : (
          <Select onValueChange={changeLanguage} value={language}>
            <SelectTrigger className={cn('w-[100px] flex justify-center items-center bg-transparent text-primary gap-2', className)}>
              <Languages className='text-primary' size={15} />
              <SelectValue placeholder={language.toUpperCase()} />
            </SelectTrigger>
            <SelectContent className='border-none bg-transparent text-primary'>
              <SelectItem value='en'>EN</SelectItem>
              <SelectItem value='es'>ES</SelectItem>
            </SelectContent>
          </Select>
        )
      }
    </>
  )
}